import { type FC } from "react";
import { CircleAlert } from "lucide-react";
import { Callout } from "@/shared/components/ui/callout";

export function SectionNumber({ n }: { n: number }) {
  return (
    <span className="inline-flex size-6 items-center justify-center rounded-full bg-stone-100 text-2xs text-secondary">
      {n}
    </span>
  );
}

interface AttentionBannerProps {
  count: number;
  sectionNumbers?: number[];
}

export const AttentionBanner: FC<AttentionBannerProps> = ({ count, sectionNumbers }) => {
  let label: string;
  if (sectionNumbers && sectionNumbers.length > 0) {
    const sectionWord = sectionNumbers.length === 1 ? "Section" : "Sections";
    label = `${sectionWord} ${sectionNumbers.join(" and ")} need${sectionNumbers.length === 1 ? "s" : ""} your attention`;
  } else {
    label =
      count === 1
        ? "1 field needs your attention: highlighted below"
        : `${count} fields need your attention: highlighted below`;
  }
  return <Callout variant="warning" icon={<CircleAlert className="h-4 w-4" />} title={label} />;
};
